function initializeTabs() {
  const tabsTopElement = document.querySelector('#tabsTop');
  const menuTabElement = document.querySelector('#menuTab');

  menuTabElement.addEventListener('click', (event) => {
    const targetButtonElement = event.delegateTarget;

    if (!targetButtonElement) {
      return;
    }

    const elementClasses = targetButtonElement.classList;

    if (elementClasses.contains('nav-link')) {
      if (!isCoverImageVisible()) {
        tabsTopElement.scrollIntoView(true);
      }

      const tabId = targetButtonElement.dataset.tabId;
      replaceCoverImage(tabId);

      if (tabId === 'wine') {
        handleWineTab();
      }
    }
  });
}

function replaceCoverImage(tabId) {
  const coverImages = {
    starters: 'images/static/menu/cover/starters.png',
    main: 'images/static/menu/cover/main.png',
    vege: 'images/static/menu/cover/vege.png',
    sweet: 'images/static/menu/cover/sweet.png',
    wine: 'images/static/menu/cover/wine.png',
  };
  const defaultCoverImage = 'images/static/menu/cover/main.png';

  const imageLocation = coverImages[tabId] || defaultCoverImage;

  const coverImageElement = document.querySelector('#coverImage');

  if (coverImageElement) {
    coverImageElement.src = imageLocation;
  }
}

function isCoverImageVisible() {
  const coverImageElement = document.querySelector('#coverImage');
  const imgClientBoundingRect = coverImageElement.getBoundingClientRect();
  return imgClientBoundingRect.bottom > 151;
}

function handleWineTab() {
  autoplayWineTabVideos();
}

function autoplayWineTabVideos() {
  const wineTopVideoElement = document.querySelector('#wine-top');

  if (wineTopVideoElement && wineTopVideoElement.play) {
    wineTopVideoElement.play();
  }

  const wineBottomVideoElement = document.querySelector('#wine-bottom');

  if (wineBottomVideoElement && wineBottomVideoElement.src) {
    wineBottomVideoElement.src = wineBottomVideoElement.src.replace(
      'autoplay=0',
      'autoplay=1'
    );
  }
}

initializeTabs();
